import React from 'react'
import {Box} from '@primer/components'
import InterHeading from './InterHeading.js'
import FaqContent from '../components/FaqContent.js'
import BgImage from '../components/BgImage.js'

export default () => (
  <BgImage pt={3} mx="auto" maxWidth="1280px"
    backgroundImage="url(https://user-images.githubusercontent.com/334891/57201655-f1c54f80-6f69-11e9-9c84-9f4c855fb3de.png)" 
    backgroundPosition="top left" 
    backgroundRepeat="no-repeat"
    backgroundSize={["50%", "28%"]}
  >
    <Box py={8} mx={[2, 4, "80px"]}>
      <InterHeading textAlign="center" fontSize={5} mb={8}>Frequently asked questions</InterHeading>
        <FaqContent />
    </Box>
  </BgImage>
)